function SocialIcon({ title, ref, svgPath }) {
  return (
    <a
      className="social-icon"
      href={ref}
      title={title}
      target="_blank"
      rel="noreferrer"
    >
      <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24">
        <path d={svgPath} />
      </svg>
    </a>
  );
}

export default SocialIcon;
